import {
  GET_COUNTRIES_ERROR,
  GET_COUNTRIES_FINISH,
  GET_COUNTRIES_START,
} from "store/actionTypes/country";

import { apiRequest } from "api-client";
import apiEndpoints from "constants/endpoints";

export const getCountries = () => {
  return (dispatch) => {
    dispatch({
      type: GET_COUNTRIES_START,
    });
    apiRequest.get(`/${apiEndpoints.countries}`)
      .then((data) => {
        dispatch({
          type: GET_COUNTRIES_FINISH,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_COUNTRIES_ERROR,
          payload: err,
        });
      });
  };
};
